const rawApiBaseUrl = process.env.REACT_APP_API_URL?.trim();

export const API_BASE_URL = (
  rawApiBaseUrl && rawApiBaseUrl.length > 0 ? rawApiBaseUrl : "/api"
).replace(/\/+$/, "");

export const buildApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
